import {
  CCreateElement,
  CSidebar,
  CSidebarBrand, CSidebarMinimizer, CSidebarNav,
  CSidebarNavDivider, CSidebarNavDropdown,
  CSidebarNavItem, CSidebarNavTitle
} from '@coreui/react'
import React, { useState } from 'react'
import navigations from './_nav'
import {useAuth} from '../contexts/AuthContext'

function Sidebar(){
  const { sidebarShow, setToggleSidebar} = useAuth()

  return (
    <CSidebar 
      show={sidebarShow}
      onShowChange={(val) => setToggleSidebar(val)}
    >
      <CSidebarBrand className="d-md-down-none" >
        <h5>MIZO BIBLE KJV</h5>
        {/* <CIcon
          className="c-sidebar-brand-full"
          name="logo-negative"
          height={35}
        />
        <CIcon
          className="c-sidebar-brand-minimized"
          name="sygnet"
          height={35}
        /> */}
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navigations}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  )
}

export default React.memo(Sidebar)
